import React, { useState, useEffect } from 'react';
import { cityService } from '../api/cityService';
import Table from '../components/Common/Table';
import Modal from '../components/Common/Modal';
import Pagination from '../components/Common/Pagination';
import CityForm from '../components/Cities/CityForm';
import '../components/Common/Common.css';

function Cities() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editingCity, setEditingCity] = useState(null);

  const fetchCities = async () => {
    try {
      setLoading(true);
      const response = await cityService.getCities({
        page: currentPage,
        per_page: 15,
      });
      setCities(response.data);
      setLastPage(response.last_page || 1);
    } catch (error) {
      console.error('Error fetching cities:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCities();
  }, [currentPage]);

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce city ?')) {
      try {
        await cityService.deleteCity(id);
        fetchCities();
      } catch (error) {
        console.error('Error deleting city:', error);
        alert('Échec de la suppression du city');
      }
    }
  };

  const handleEdit = (city) => {
    setEditingCity(city);
    setShowModal(true);
  };

  const handleCreate = () => {
    setEditingCity(null);
    setShowModal(true);
  };

  const handleFormSuccess = () => {
    setShowModal(false);
    setEditingCity(null);
    fetchCities();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Ville' },
    { key: 'delivery_fee', label: 'Frais de livraison' },
    {
      key: 'is_active',
      label: 'Statut',
      render: (val) => <span className={`badge ${val ? 'badge-success' : 'badge-danger'}`}>{val ? 'Actif' : 'Inactif'}</span>
    },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Cities</h1>
        <button onClick={handleCreate} className="btn btn-primary">
          Ajouter un city
        </button>
      </div>

      <Table
        columns={columns}
        data={cities}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <Pagination
        currentPage={currentPage}
        lastPage={lastPage}
        onPageChange={setCurrentPage}
      />

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title={editingCity ? 'Modifier le city' : 'Ajouter un city'}
      >
        <CityForm
          city={editingCity}
          onSuccess={handleFormSuccess}
          onCancel={() => setShowModal(false)}
        />
      </Modal>
    </div>
  );
}

export default Cities;
